module.exports = require("idb-keyval");